import sessionService from '_services/common/sessionService';
import FeedService from '_services/rest/modules/feed';

export default {
  state: {
    authResponse: sessionService.getLocalData('_FB_auth'),
    filterList: null,
    tagFilterList: null,
    tagList: null,
  },
  mutations: {
    setFBToken(state, response) {
      state.authResponse = response;
    },
    setFilterList(state, response) {
      state.filterList = response;
    },
    setTagFilterList(state, response) {
      state.tagFilterList = response;
    },
    setTagList(state, response) {
      state.tagList = response;
    },
  },
  actions: {
    setFBToken({ commit }, params) {
      return FeedService.getLongAccessToken(params)
        .then(response => {
          sessionService.setLocalData('_FB_auth', response);
          commit('setFBToken', response);
          return response;
        });
    },
    getFilterList({ commit }) {
      FeedService.getFilter()
        .then(response => {
          commit('setFilterList', response);
        });
    },
    getTagFilterList({ commit }) {
      FeedService.getTagFilter()
        .then(response => {
          commit('setTagFilterList', response);
        });
    },
    getTagList({ commit }, params) {
      FeedService.getTags(params)
        .then(response => {
          commit('setTagList', response);
        });
    },
    setFilterList({ commit }, params) {
      commit('setFilterList', params);
    },
    updateFilterList({ commit, state }, newFilter) {
      const filtersList = state.filterList.concat(newFilter);
      commit('setFilterList', filtersList);
    },
    logoutFB({ commit }) {
      sessionService.removeSession('_FB_auth');
      commit('setFBToken', null);
    },
  },
};
